import styled from 'styled-components';
import { Input, Button, Form, Select } from 'antd';

import { tangerineGradient, tangerineGradientRevert } from '../../styles';

const FItem = Form.Item;


export const FormItem = styled(FItem)`
  margin-bottom: 10px;
  label {
    color: ${props => props.theme.colors.mainDark};
  }
  .ant-form-item-label {
    line-height: 2;
  }
  .dynamic-delete-button {
    cursor: pointer;
    position: relative;
    top: 4px;
    font-size: 24px;
    color: #999;
    transition: all 0.3s;
  }
  .dynamic-delete-button:hover {
    color: #777;
  }
  .dynamic-delete-button[disabled] {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const InputField = styled(Input)`
  font-size: 14px;
`;

export const StyledSelect = styled(Select)`
  .ant-select-selection--single {
    height: 40px;
  }
  .ant-select-selection__rendered {
    line-height: 40px;
  }
`;

export const Title = styled.div`
  text-align: center;
  font-size: 24px;
  font-weight: normal;
  color: ${props => props.theme.colors.fontSilverDark};
  margin-bottom: 30px;  
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  &.centered {
    justify-content: center;
  }
`;

export const ButtonSave = styled(Button)`
  margin-top: 15px;
  ${tangerineGradient};
  color: ${props => props.theme.colors.white};
  width: 150px;
  height: 38px;
  font-size: 15px;
  border-radius: 5px;
  border: none;
  &:hover,
  &:focus {
    ${tangerineGradientRevert};
  }
  &.centered {
    width: 120px;
    height: 30px;
    font-size: 16px;
    border-radius: 30px;
  }
`;

export const RoundButtonCancel = styled(Button)`
  margin-top: 15px;
  background-color: ${props => props.theme.colors.fontSilver};
  color: ${props => props.theme.colors.white};
  border-radius: 30px;
  width: 120px;
  height: 30px;
  font-size: 16px;
  margin-right: 6px;
  border: none;
  &:hover,
  &:focus {
    background-color: ${props => props.theme.colors.fontSilverLight};
    color: ${props => props.theme.colors.white};
  }
`;

export const SelectDropdown = styled.div`
  .ant-select-dropdown-menu-item {
    padding: 10px 0 0 10px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/contact-form/styled-components.js